import cn from 'classnames';
import { Fragment } from 'react';

import style from 'styles/components/menuSearch/MealCardsList';
import * as Types from 'utilities/types';

import CTABanner from './CTABanner';
import MealCard from './MealCard';

const MealCardsList = ({
  meals = [],
  searchTerm,
  showUnconvertedLead,
  subtitle,
  title,
  mealPlanSlug,
}) => {
  const renderCTA = index => meals.length >= 8 && index === 3;

  return (
    <>
      <div className="mb-6">
        <h3 className={cn(style.availableToOrder, 'leading-10 text-charcoal-100')}>{title}</h3>
        {subtitle && <h4 className="h5 font-normal text-charcoal-100">{subtitle}</h4>}
      </div>
      <ul className="flex list-none flex-wrap">
        <ul className="flex list-none flex-wrap">
          {meals.map((meal, index) => (
            <Fragment key={meal.id}>
              <li className={cn(style.listItem)}>
                <MealCard meal={{ ...meal, url: `${meal.url}?search_term=${searchTerm}` }} />
              </li>
              {renderCTA(index) && (
                <li className="mb-6 w-full">
                  <CTABanner
                    showUnconvertedLead={showUnconvertedLead}
                    mealPlanSlug={mealPlanSlug}
                  />
                </li>
              )}
            </Fragment>
          ))}
        </ul>
      </ul>
    </>
  );
};

MealCardsList.propTypes = {
  meals: PropTypes.arrayOf(Types.meal),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  showUnconvertedLead: PropTypes.bool,
  searchTerm: PropTypes.string,
  mealPlanSlug: PropTypes.string,
};

export default MealCardsList;
